module.exports = __webpack_public_path__ + "static/img/fazhan_03.07a0434.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/aboutPage/fazhan_03.jpg
// module id = AVRZ
// module chunks = 14